import {
    setSliceModel,
    setSliceRatio,
    setSliceQuality,
    setSliceDuration,
    setSliceTabIndex,
    setSliceTVTextValue,
    setSliceIVTextValue,
    setSliceOriginImage,
    setVideoEffectUploadImageInfo,
    setSliceUploadStatus,
    setSliceInspireList,
    setSlicePresetList,
    setSliceCurrentTackId,
    setSliceCurrentGenerateStatus,
    setSliceGeneratingVideoNum,
    setSliceIsShowGeneratingVideoNum,
    setSliceIVFreeNumCreationAction,
    setSliceTVFreeNumCreationAction,
    setSliceSortType,
    setSliceVideoEffectPresetList,
    setSliceVideoEffectUploadTwoImageInfo,
    setSliceEVTextValue,
    setSliceVideoEffectImageTypeIndex,
    setVideoEffectStyleSelectId,
    setSliceModelPickerVisible,
    setSliceImageMode,
    updateSliceUploadImage,
    removeSliceUploadImage,
    setSliceAudioActive,
    setSliceCurrentSubmitParams,
    setSliceReset,
    setSliceResolution,
    setSliceDancePresetList,
    setSliceVideoEffectUploadVideoInfo,
    setSliceIVPrivacyStatus,
    setSliceTVPrivacyStatus,
    setSliceEVPrivacyStatus,
    setSliceMotionControlImage,
    setSliceMotionControlVideo,
    setSliceCurCharacterOrientation,
    setSliceMotionControlTextSwitch,
} from '../slices/FJSliceAIVideoGenerator';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJUtil from '../../util/FJUtil.js';
import FJCompressedImageStore from '../../store/FJCompressedImageStore.js';
import FJConstant from '../../constants/FJConstant.js';
import FJConfig from '../../config/FJConfig';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJS3Config from '../../config/FJS3Config.js';
import FJActionCommon from './FJActionCommon.js';
import {
    MAX_COMPRESS_IMAGE_SIZE,
    MAX_POLLING_ERROR_TIME,
    TASK_POLLING_INTERVAL,
} from '../../config/dataConfig/FJGenerateData.js';
import FJAppConstant from '../../constants/FJAppConstant.js';
import {
    setSliceCreationListAction,
    setSliceHistoryListAction,
    setSliceRetryLoadingIds,
    setSliceTaskStatusAction,
} from '../slices/FJSliceCommon.js';
import { UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE } from '../../config/dataConfig/FJGenerateData';
import FJImageStore from '../../store/FJImageStore.js';
import FJActionModal from './FJActionModal.js';
import {
    AI_GENERATOR_VIDEO_TAB_TYPE,
    AI_VIDEO_GENERATION_MODEL_LIST,
    getModelRatios,
    getModelDurations,
    IMAGE_UPLOAD_MODES,
    MODEL_VALUE_MAP,
    VIDEO_GENERATOR_MARKETING_PARAMS_MAP,
    UPLOAD_VIDEO_TO_VIDEO_EFFECT,
    LANDING_PAGE_MODEL_VALUE_MAP,
} from '../../config/dataConfig/FJAIVideoGeneratorData.js';
import { VIDEO_EFFECT_STYLE_LIST } from '../../config/dataConfig/FJVideoEffectData.js';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore.js';
import FJAIVideoGeneratorConfig from '../../config/appConfig/FJAIVideoGeneratorConfig.js';
import FJStringUtil from '../../util/FJStringUtil.js';
import FJHeaderConfig from '../../config/FJHeaderConfig.js';
import FJFileHandleUtil from '../../util/FJFileHandleUtil.js';
import FJEaLogDataUtil from '../../util/FJEaLogDataUtil.js';
import { AI_VIDEO_DUB_USE_CREDIT } from '../slices/FJSliceAiVideoDub.js';
import FJRequirementsUtil from '../../util/FJRequirementsUtil.js';
import FJVideoUtil from '../../util/FJVideoUtil.js';
import FJActionEditPage from './FJActionEditPage.js';
import FJUserSelectionStore, { SELECTION_KEYS } from '../../store/FJUserSelectionStore';
import FJVersionConfig from '../../config/FJVersionConfig.js';

let f_isFirstShowGeneratingVideoNum = false;
let f_timer = null;
let f_errorTime = 0;
let f_isPolling = false;

let f_failInfo = [];

// 获取水印比例
const _getWaterfallRatio = async (url, ratio, currentModel) => {
    const modelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === currentModel);
    if (url && !modelConfig.supportImageSelectRatio) {
        try {
            return await FJImageStore.getImageRatio(url);
        } catch (e) {
            return await FJImageStore.getImageRatio(url + `?v=${new Date().getTime()}`);
        }
    } else if (ratio) {
        const [a, b] = ratio.split(':').map(item => Number(item));
        return a / b;
    } else {
        return 16 / 9;
    }
};
const _judgeDouBaoImageValidate = (currentModel, options = {}) => {
    const { width, height } = options;
    if (currentModel === MODEL_VALUE_MAP.PRO_I2V || currentModel === MODEL_VALUE_MAP.ULTRA) {
        return width / height >= 0.4 && width / height <= 2.5;
    } else {
        return true;
    }
};
const _judgeImageRatioValidate = ({ width, height, minRatio = 0.4, maxRatio = 2.5 }) => {
    return width / height >= minRatio && width / height <= maxRatio;
};
let _currentId = null;

// eslint-disable-next-line no-unused-vars
const _checkIsCurrentTimingId = currentTimingId => {
    return _currentId === currentTimingId;
};
const FJActionAIVideoGenerator = {
    setModelAction: function (model) {
        return (dispatch, getState) => {
            const { currentModel } = getState().AIVideoGenerator;
            if (currentModel !== model.value) {
                dispatch(setSliceModel(model));
                FJUserSelectionStore.save(FJAppConstant.AI_VIDEO_GENERATOR, SELECTION_KEYS.CUR_MODEL, model.value);
            }
        };
    },

    /**
     * @description 设置图片生成隐私状态
     * @param {string} status - 隐私状态
     * @returns {(function(*): void)|*}
     */
    setIVPrivacyStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceIVPrivacyStatus(status));
        };
    },

    /**
     * @description 设置视频生成隐私状态
     * @param {string} status - 隐私状态
     * @returns {(function(*): void)|*}
     */
    setTVPrivacyStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceTVPrivacyStatus(status));
        };
    },

    /**
     * @description 设置特效生成隐私状态
     * @param {string} status - 隐私状态
     * @returns {(function(*): void)|*}
     */
    setEVPrivacyStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceEVPrivacyStatus(status));
        };
    },
    /**
     * @description 重置数据
     * @returns {(function(*): void)|*}
     */
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceReset());
        };
    },

    /**
     * @description 编辑页面的AI工具关闭的时候调用
     * @returns {(function(*))|*}
     */
    editCloseAction: function () {
        return () => {
            _currentId = null;
        };
    },

    setSortTypeAction: function (type) {
        return dispatch => {
            dispatch(setSliceSortType(type));
        };
    },
    changeResolutionAction: function (resolution) {
        return (dispatch, getState) => {
            const { currentModel, currentDuration, currentResolution } = getState().AIVideoGenerator;
            const { creditNumber } = getState().common;
            if (resolution !== currentResolution) {
                const modelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(model => model.value === currentModel);
                const newRslItem = modelConfig?.resolutions?.find(item => item.value === resolution);
                const newCreditPrice = modelConfig?.creditPriceLevels?.[resolution] || modelConfig?.creditPrice || 2;
                const newDurationList = newRslItem?.supportDurations
                    ? modelConfig?.durations.filter(duration => newRslItem.supportDurations.includes(duration.value))
                    : modelConfig?.durations || [];
                const isDurationSupported = newDurationList.some(duration => duration.value === currentDuration);
                const newDuration = isDurationSupported ? currentDuration : newDurationList[0]?.value || null;

                if (newCreditPrice * newDuration > creditNumber && FJUtil.isLogin()) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }
            }
            dispatch(setSliceResolution(resolution));
        };
    },
    changeModelAction: function (model) {
        return (dispatch, getState) => {
            const state = getState();
            const { imageMode } = state.AIVideoGenerator;

            // 如果当前是首尾帧模式，需要判断新模型是否支持
            if (imageMode === IMAGE_UPLOAD_MODES.START_END) {
                const newModelConfig = model;

                // 如果新模型不支持首尾帧，则切换回单图模式
                if (!newModelConfig || newModelConfig.mode !== IMAGE_UPLOAD_MODES.START_END) {
                    dispatch(setSliceImageMode(IMAGE_UPLOAD_MODES.SINGLE));
                } else {
                    dispatch(this.setModelAction(model));
                    dispatch(setSliceImageMode(IMAGE_UPLOAD_MODES.START_END));
                    return;
                }
            }

            dispatch(this.setModelAction(model));
        };
    },

    toggleAudioActiveAction: function (isActive) {
        return (dispatch, getState) => {
            const isLogin = FJUtil.isLogin();

            // 如果登录，判断积分是否足够支付音频费用
            if (isLogin && isActive) {
                const { creditNumber } = getState().common;
                const { currentDuration } = getState().AIVideoGenerator;
                const { currentModel, currentResolution } = getState().AIVideoGenerator;
                const currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(model => model.value === currentModel);
                const totalCredit =
                    (currentModelConfig.creditPriceLevels?.[currentResolution] || currentModelConfig.creditPrice) *
                    currentDuration;

                if (creditNumber < totalCredit + currentDuration * AI_VIDEO_DUB_USE_CREDIT) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }
            }

            dispatch(setSliceAudioActive(isActive));
        };
    },

    /**
     * 获取所有可用的模型列表
     */
    getAvailableModelsAction: function () {
        return () => {
            return AI_VIDEO_GENERATION_MODEL_LIST;
        };
    },

    /**
     * 根据模型获取可用的比例选项
     */
    getAvailableRatiosAction: function (model) {
        return () => {
            return getModelRatios(model);
        };
    },

    /**
     * 根据模型获取可用的时长选项
     */
    getAvailableDurationsAction: function (model) {
        return () => {
            return getModelDurations(model);
        };
    },

    /**
     * 切换模型选择器显示状态
     * @param {boolean} isVisible - true为显示，false为隐藏
     */
    toggleModelPickerVisibilityAction: function (isVisible) {
        return dispatch => {
            dispatch(setSliceModelPickerVisible(isVisible));
        };
    },

    changeRatioAction: function (ratio) {
        return dispatch => {
            dispatch(setSliceRatio(ratio));
        };
    },

    changeQualityAction: function (quality) {
        return dispatch => {
            dispatch(setSliceQuality(quality));
        };
    },

    changeDurationAction: function (duration) {
        return dispatch => {
            dispatch(setSliceDuration(duration));
        };
    },

    changeTabIndexAction: function (tab, options = {}) {
        return (dispatch, getState) => {
            const { ignoreTitle = false } = options;
            const currentModel = getState().AIVideoGenerator.currentModel;
            // 检查当前模型是否支持新的tab
            const currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(model => model.value === currentModel);
            const isCurrentModelSupported = currentModelConfig?.supportedModes?.includes(tab);

            // 如果当前模型不支持新的tab且不是视频特效，切换到默认的pro模型
            if (!isCurrentModelSupported && tab !== AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO) {
                const proI2VModel = AI_VIDEO_GENERATION_MODEL_LIST.find(
                    model => model.value === MODEL_VALUE_MAP.PRO_I2V,
                );
                const proT2VModel = AI_VIDEO_GENERATION_MODEL_LIST.find(
                    model => model.value === MODEL_VALUE_MAP.PRO_T2V,
                );

                if (proI2VModel && proI2VModel.supportedModes?.includes(tab)) {
                    dispatch(this.setModelAction(proI2VModel));
                } else if (proT2VModel && proT2VModel.supportedModes?.includes(tab)) {
                    dispatch(this.setModelAction(proT2VModel));
                }
            }

            dispatch(setSliceTabIndex(tab));

            if (!FJUtil.isSpecialPage() && !ignoreTitle) {
                const tag = FJLocalStore.currentTag();
                let linkTag = tag === 'en' ? `` : `/${tag}`;
                const { origin, search } = window.location;
                const href = FJUtil.getAIToolHref(tab);
                FJUtil.changeLocation(`${origin}${linkTag}${href}${search}`);
                FJUtil.updateDocumentTitle(FJAppConstant.AI_VIDEO_GENERATOR);
            }
        };
    },

    changeTextValueAction: function (value) {
        return (dispatch, getState) => {
            const tabIndex = getState().AIVideoGenerator.tabIndex;
            if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO) {
                dispatch(setSliceTVTextValue(value));
            } else if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO) {
                dispatch(setSliceIVTextValue(value));
            } else if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO) {
                dispatch(setSliceEVTextValue(value));
            }
        };
    },

    changeOriginImageInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceOriginImage({ ...info }));
        };
    },

    changeUploadStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceUploadStatus(status));
        };
    },
    clearFileAction: function () {
        return dispatch => {
            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
            dispatch(this.changeOriginImageInfoAction({}));
        };
    },

    /**
     * 上传文件
     * @param {File} file - 文件
     * @param {number} index - 索引，默认0 用于多图上传
     */
    uploadFileAction: function (file, index = 0, options = {}) {
        return async (dispatch, getState) => {
            let { skipTranscoded = false, originFileInfo = null, isUploadVideo = false } = options;
            const { currentModel, tabIndex, uploadStatus, videoEffectStyleSelectId } = getState().AIVideoGenerator;
            const currentItem = VIDEO_EFFECT_STYLE_LIST.find(item => item.key === videoEffectStyleSelectId);

            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const __fileError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            };
            const isVideo = FJUtil.isVideo(file, UPLOAD_VIDEO_TO_VIDEO_EFFECT);
            const isImage = FJUtil.isImage(file, false, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);

            const isVideoEffect = tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO;

            if (isImage && !isUploadVideo) {
                if (!isVideoEffect) {
                    dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
                }

                let isImageExceedSize = false;
                try {
                    // 判断图片是否小于300px
                    isImageExceedSize = await FJUtil.checkImageSize(file);
                    if (isImageExceedSize) {
                        FJMessageStore.addMessage(FJLocalStore._('the-image-should-be-larger-than'), 'error');
                        dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                        return;
                    }
                } catch (e) {
                    __fileError();
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    return;
                }

                let data = await FJCompressedImageStore.compressImageByFile(file, {
                    maxPixel: isVideoEffect ? 1000 : MAX_COMPRESS_IMAGE_SIZE,
                });
                if (!_judgeDouBaoImageValidate(currentModel, data) && !isVideoEffect) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-image-ratio-please-upload-a-new-file'),
                        'error',
                    );
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    return;
                }

                if (data) {
                    if (isVideoEffect) {
                        if (
                            currentItem.key === 'dancing' ||
                            currentItem.key === 'mimic-motion' ||
                            currentItem.key === 'character-swap'
                        ) {
                            const { width, height } = data;
                            if (
                                Math.min(width, height) < 300 ||
                                Math.max(width, height) > 4096 ||
                                Math.max(width, height) / Math.min(width, height) > 3
                            ) {
                                FJMessageStore.addMessage(
                                    FJLocalStore._('the-aspect-ratio-of-the-image-should-be-between-13-and-31'),
                                    'error',
                                );
                                dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                                return;
                            }
                        }
                        dispatch(
                            this.updateVideoEffectUploadFileAction(
                                { ...data, type: 'local', mediaType: 'IMAGE', source: FJConstant.LOCAL },
                                index,
                            ),
                        );
                    } else {
                        dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));
                        dispatch(
                            this.updateUploadMediaAction(index, {
                                ...data,
                                originFileInfo,
                                type: 'local',
                                source: FJConstant.LOCAL,
                            }),
                        );
                    }
                } else {
                    __fileError();
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                }
            } else if (isVideo && isUploadVideo) {
                if (isVideoEffect) {
                    const videoInfo = await FJVideoUtil.loadVideo(file);
                    const ext = file.name.split('.').pop();

                    if (videoInfo) {
                        // 视频时长不能小于2秒，不能大于30秒  三个模型 ['dancing', 'mimic-motion', 'character-swap']
                        if (videoInfo.duration < 2 || videoInfo.duration > 30) {
                            FJMessageStore.addMessage(FJLocalStore._('video-duration-should-be-2-30-seconds'), 'error');
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                            return;
                        }

                        dispatch(
                            this.updateVideoEffectUploadVideoInfoAction({
                                ...videoInfo,
                                end: videoInfo.duration,
                                type: 'local',
                                mediaType: 'VIDEO',
                                source: FJConstant.LOCAL,
                                ext,
                            }),
                        );
                    } else {
                        __fileError();
                        dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    }
                }
            } else {
                if (skipTranscoded) {
                    __fileError();
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: isUploadVideo ? 'video' : 'image',
                            outputFormat: isUploadVideo ? 'mp4' : 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadFileAction(newFiles[0], index, { ...options }));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    dispatch(this.uploadFileAction(result.files[0], index, { skipTranscoded: true, ...options }));
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        __fileError();
                    }
                    dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    return;
                }
            }
        };
    },
    uploadMotionControlImageAction: function (file, options = {}) {
        const { skipTranscoded } = options;
        return async dispatch => {
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                FJMessageStore.addMessage(FJLocalStore._('the-max-image-size-is-xxx-mb').replace('xxx', 10), 'error');
                return;
            }
            const __fileError = () => {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            };
            const isImage = FJUtil.isImage(file, false, UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE);

            if (isImage) {
                let isImageExceedSize = false;
                try {
                    // 判断图片是否小于300px
                    isImageExceedSize = await FJUtil.checkImageSize(file, { pixel: 340 });
                    if (isImageExceedSize) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('upload-failed-please-upload-images-within-the-range-of-340px-3850px'),
                            'error',
                        );
                        return;
                    }
                } catch (e) {
                    __fileError();
                    return;
                }

                let data = await FJCompressedImageStore.compressImageByFile(file, {
                    maxPixel: 2000,
                });
                if (!_judgeImageRatioValidate(data)) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('the-aspect-ratio-of-the-image-should-be-between-1-2-5-and-2-5-1'),
                        'error',
                    );
                    return;
                }
                if (data) {
                    dispatch(
                        setSliceMotionControlImage({
                            ...data,
                            type: 'local',
                            source: FJConstant.LOCAL,
                        }),
                    );
                } else {
                    __fileError();
                }
            } else {
                if (skipTranscoded) {
                    __fileError();
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'image',
                            outputFormat: 'png',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadMotionControlImageAction(newFiles[0], options));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    dispatch(this.uploadMotionControlImageAction(result.files[0], { skipTranscoded: true }));
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        __fileError();
                    }
                    return;
                }
            }
        };
    },
    deleteMotionControlImageAction: function () {
        return dispatch => {
            dispatch(setSliceMotionControlImage({}));
        };
    },
    uploadMotionControlVideoAction: function (file, options = {}) {
        const { skipTranscoded } = options;
        return async (dispatch, getState) => {
            const { curCharacterOrientation } = getState().AIVideoGenerator;
            const maxSize = 100 * 1024 * 1024; // 10MB
            if (file.size > maxSize) {
                FJMessageStore.addMessage(FJLocalStore._('the-max-video-size-is-xxx-mb').replace('xxx', 100), 'error');
                return;
            }
            const isVideo = FJUtil.isVideo(file, UPLOAD_VIDEO_TO_VIDEO_EFFECT);
            const __fileError = () => {
                FJMessageStore.addMessage(FJLocalStore._('unsupported-format-video-remove-bg'), 'error');
            };
            if (isVideo) {
                const videoInfo = await FJVideoUtil.loadVideo(file);
                const ext = file.name.split('.').pop();
                const maxDuration = curCharacterOrientation === 'video' ? 30 : 10;
                if (videoInfo) {
                    if (videoInfo.duration < 3 || videoInfo.duration > maxDuration) {
                        const message =
                            curCharacterOrientation === 'video'
                                ? FJLocalStore._('the-video-length-should-within-the-range-of-3-30-seconds')
                                : FJLocalStore._(
                                    'when-character-orientation-is-image-video-length-must-be-3-10-seconds',
                                );
                        FJMessageStore.addMessage(message, 'error');
                        return;
                    }

                    dispatch(
                        setSliceMotionControlVideo({
                            ...videoInfo,
                            end: videoInfo.duration,
                            type: 'local',
                            mediaType: 'VIDEO',
                            source: FJConstant.LOCAL,
                            ext,
                        }),
                    );
                } else {
                    __fileError();
                    return;
                }
            } else {
                if (skipTranscoded) {
                    __fileError();
                    return;
                }
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'video',
                            outputFormat: 'mp4',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadMotionControlVideoAction(newFiles[0], options));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    dispatch(this.uploadMotionControlVideoAction(result.files[0], { skipTranscoded: true }));
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        __fileError();
                    }
                    return;
                }
            }
        };
    },
    onMotionControlPresetClickAction: function (item) {
        return async dispatch => {
            const { previewVideo } = item;
            const videoUrl =
                FJAIVideoGeneratorConfig.motionControlPreviewPath +
                previewVideo +
                '?v=' +
                FJVersionConfig.staticPathVersion;
            const duration = await FJVideoUtil.getVideoDurationWithUrl(videoUrl);
            dispatch(
                setSliceMotionControlVideo({
                    width: 480,
                    height: 720,
                    src: videoUrl,
                    duration: duration,
                    end: duration,
                    type: 'web',
                    mediaType: 'VIDEO',
                }),
            );
        };
    },
    deleteMotionControlVideoAction: function () {
        return dispatch => {
            dispatch(setSliceMotionControlVideo({}));
        };
    },
    changeCharacterOrientationAction: function (orientation) {
        return (dispatch, getState) => {
            const { motionControlVideo } = getState().AIVideoGenerator;
            dispatch(setSliceCurCharacterOrientation(orientation));
            if (orientation === 'image') {
                if (motionControlVideo?.duration > 10) {
                    dispatch(this.deleteMotionControlVideoAction());
                    FJMessageStore.addMessage(
                        FJLocalStore._('when-character-orientation-is-image-video-length-must-be-3-10-seconds'),
                        'error',
                    );
                }
            }
        };
    },

    updateEffectVideoPresetIdAction: function (effectId) {
        return async dispatch => {
            const videoEffectStyleItem = VIDEO_EFFECT_STYLE_LIST.find(item => item.key === effectId);
            // 先定位风格
            if (videoEffectStyleItem) {
                dispatch(setVideoEffectStyleSelectId(effectId));
                await FJUtil.wait(0.2);
                // 特殊做法 因为useEffect中有EffectStyleSelectId改变的时候会设置changeVideoEffectImageTypeIndexAction为0
                if (videoEffectStyleItem.list.length > 1) {
                    dispatch(this.changeVideoEffectImageTypeIndexAction(videoEffectStyleItem.list.length > 1 ? 1 : 0));
                }
            }
        };
    },

    initAIVideoGeneratorAction: function () {
        return async dispatch => {
            dispatch(this._initInspireListAction());
            dispatch(this._initPresetAIVideoAction());
            await dispatch(this._initVideoEffectAction());

            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;

            const effectId = FJUtil.getQueryString('effect_id');
            if (effectId) {
                dispatch(this.updateEffectVideoPresetIdAction(effectId));
            }

            // 营销页面，根据外部传入的model_type设置模型
            const model_type = FJUtil.getQueryString('model_type');
            const model_type_value = model_type && VIDEO_GENERATOR_MARKETING_PARAMS_MAP[model_type];
            let landingPageModelValue = null;
            if (FJUtil.isAiVideoGeneratorLandingPage()) {
                const pathName = FJUtil.getPathName();
                for (let index = 0; index < Object.keys(LANDING_PAGE_MODEL_VALUE_MAP).length; index++) {
                    const key = Object.keys(LANDING_PAGE_MODEL_VALUE_MAP)[index];
                    if (pathName.includes(key)) {
                        landingPageModelValue = LANDING_PAGE_MODEL_VALUE_MAP[key];
                        break;
                    }
                }
            }
            const modelValue = model_type_value || landingPageModelValue;
            if (modelValue) {
                const currentModel = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === modelValue);
                currentModel && dispatch(this.setModelAction(currentModel));
            }

            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                if (recIdInfo?.fromType === FJConstant.COMMUNITY) {
                    dispatch(FJActionCommon.onRecreateAction(recIdInfo));
                } else {
                    dispatch(this.handleRecInfoAction(recIdInfo));
                }
            }
            const tabType = FJUtil.getQueryString('tab_type');
            if (tabType && ['tv', 'iv'].includes(tabType)) {
                // todo 缺视频特效
                const tabIndex =
                    tabType === 'tv'
                        ? AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO
                        : AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO;
                dispatch(this.changeTabIndexAction(tabIndex));
            }
        };
    },
    handleRecInfoAction: function (recIdInfo) {
        return async (dispatch, getState) => {
            const state = getState();
            if (recIdInfo) {
                const {
                    generationType,
                    prompt,
                    ratio = '16:9',
                    duration = 5,
                    modelType,
                    imageUrl,
                    fileList,
                    avator,
                    currentImageMode,
                    startImage,
                    endImage,
                    multiImage,
                    image,
                    isDubbing,
                    images
                } = recIdInfo;
                if (state.AIVideoGenerator.tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO) {
                    if (fileList) {
                        // 上传图片
                        const fileInfo = fileList[0]?.info;
                        if (!fileInfo) return;
                        const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                        const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                        dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                    } else if (imageUrl) {
                        const blob = await FJFileHandleUtil.downloadImage(imageUrl);
                        const file = new File([blob], 'Image.png', { type: 'image/png' });
                        dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                    }
                } else if (fileList) {
                    // 一定是图生视频
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.changeTabIndexAction(AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO));
                    dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    const fileName = FJUtil.getFileName(avator);
                    const file = new File([blob], fileName, { type: 'image/png' });
                    dispatch(this.changeTabIndexAction(AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO));
                    dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                    dispatch(this.uploadMotionControlImageAction(blob));
                } else if (images) {
                    for (let i = 0; i < images.length; i++) {
                        const image = images[i];
                        const blob = await FJUtil.getBlobByUrl(image);
                        const fileName = FJUtil.getFileName(image);
                        const file = new File([blob], fileName, { type: 'image/png' });
                        dispatch(this.uploadFileAction(file, i, { skipTranscoded: true }));
                        i == 0 && dispatch(this.uploadMotionControlImageAction(blob));
                    }
                    dispatch(this.changeTabIndexAction(AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO));

                } else if (['tv', 'iv'].includes(generationType)) {
                    // todo 缺视频特效
                    const tabIndex =
                        generationType === 'tv'
                            ? AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO
                            : AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO;
                    dispatch(this.changeTabIndexAction(tabIndex));
                    dispatch(this.changeRatioAction(ratio));
                    dispatch(this.changeDurationAction(duration));
                    let currentModel = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === modelType);

                    if (modelType === 'v1.5') {
                        currentModel = AI_VIDEO_GENERATION_MODEL_LIST.find(
                            item =>
                                item.value ===
                                (generationType === 'iv' ? MODEL_VALUE_MAP.PRO_I2V : MODEL_VALUE_MAP.PRO_T2V),
                        );
                    } else if (modelType === 'standard') {
                        currentModel = AI_VIDEO_GENERATION_MODEL_LIST.find(
                            item => item.value === MODEL_VALUE_MAP.STANDARD,
                        );
                    }

                    currentModel && dispatch(this.setModelAction(currentModel));

                    if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO) {
                        dispatch(setSliceTVTextValue(prompt));
                    } else if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO) {
                        dispatch(setSliceIVTextValue(prompt));
                        dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));

                        if (currentImageMode === IMAGE_UPLOAD_MODES.SINGLE) {
                            const _singleImage =
                                currentModel.mode === IMAGE_UPLOAD_MODES.START_END ? startImage : image;
                            const blob = await FJFileHandleUtil.downloadImage(_singleImage);
                            const file = new File([blob], 'Image.png', { type: 'image/png' });
                            dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                        } else if (currentImageMode === IMAGE_UPLOAD_MODES.START_END) {
                            const startBlob = await FJFileHandleUtil.downloadImage(startImage);
                            const startFile = new File([startBlob], 'Image.png', { type: 'image/png' });
                            dispatch(this.uploadFileAction(startFile, 0, { skipTranscoded: true }));

                            const endBlob = await FJFileHandleUtil.downloadImage(endImage);
                            const endFile = new File([endBlob], 'Image.png', { type: 'image/png' });
                            dispatch(this.uploadFileAction(endFile, 1, { skipTranscoded: true }));

                            dispatch(setSliceImageMode(currentImageMode));
                        } else if (currentImageMode === IMAGE_UPLOAD_MODES.MULTI) {
                            for (let i = 0; i < multiImage.length; i++) {
                                const blob = await FJFileHandleUtil.downloadImage(multiImage[i]);
                                const file = new File([blob], 'Image.png', { type: 'image/png' });
                                dispatch(this.uploadFileAction(file, i, { skipTranscoded: true }));
                            }
                        } else {
                            const blob = await FJFileHandleUtil.downloadImage(imageUrl);
                            const file = new File([blob], 'Image.png', { type: 'image/png' });
                            dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                        }
                    }

                    if (currentModel.sfxSupported) {
                        dispatch(setSliceAudioActive(!!isDubbing));
                    }
                } else if (state.AIVideoGenerator.tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO && prompt) {
                    dispatch(setSliceTVTextValue(prompt));
                } else if (
                    state.AIVideoGenerator.tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO &&
                    prompt
                ) {
                    dispatch(setSliceIVTextValue(prompt));
                }
            }
        };
    },
    editHistoryItemAction: function (data) {
        return async dispatch => {
            const {
                jobType,
                effectInfo,
                prompt,
                aspectRatio,
                duration,
                modelType,
                currentImageMode,
                startImage,
                endImage,
                multiImage,
                image: imageUrl,
                originalUrl,
                generationType,
                orientation,
                videos,
            } = data;
            const image = imageUrl || originalUrl;
            if (jobType === 28) {
                dispatch(setSliceEVTextValue(prompt));

                const { effectOriginalUrlList, effect_input_video_url } = effectInfo;
                const videoEffectStyleItem = VIDEO_EFFECT_STYLE_LIST.find(
                    item => item.category === effectInfo.effect_scene,
                );
                if (videoEffectStyleItem) {
                    dispatch(setVideoEffectStyleSelectId(videoEffectStyleItem.key));
                }

                const useList = [];
                for (let i = 0; i < effectOriginalUrlList.length; i++) {
                    const item = effectOriginalUrlList[i];
                    const { width, height } = await FJImageStore.getImageInfo(item);
                    useList.push({
                        src: item,
                        width,
                        height,
                    });
                }
                if (effect_input_video_url) {
                    const file = await FJUtil.getBlobByUrl(effect_input_video_url);
                    const videoInfo = await FJVideoUtil.loadVideo(file);
                    const ext = effect_input_video_url.split('.').pop();

                    if (videoInfo) {
                        dispatch(
                            this.updateVideoEffectUploadVideoInfoAction({
                                ...videoInfo,
                                src: effect_input_video_url,
                                originalUrl: effect_input_video_url,
                                end: videoInfo.duration,
                                type: 'web',
                                mediaType: 'VIDEO',
                                source: FJConstant.AI_VIDEO_S3,
                                ext,
                            }),
                        );
                    }
                }

                if (effectOriginalUrlList.length > 1) {
                    dispatch(this.setSliceVideoEffectUploadTwoImageInfoAction(useList));
                } else {
                    dispatch(this.setSliceVideoEffectUploadImageInfoAction({ ...useList[0] }));
                }
            } else if (jobType === 14) {
                dispatch(this.changeRatioAction(aspectRatio));
                dispatch(this.changeDurationAction(duration));
                const currentModel = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === modelType);
                if (currentModel) {
                    dispatch(this.changeModelAction(currentModel));
                }
                if (generationType === 'tv') {
                    dispatch(setSliceTVTextValue(prompt));
                } else if (generationType === 'iv') {
                    dispatch(setSliceIVTextValue(prompt));
                    dispatch(setSliceImageMode(currentImageMode));
                    try {
                        if (currentModel.value === MODEL_VALUE_MAP.KLING_V26_MOTION_CONTROL) {
                            orientation && dispatch(setSliceCurCharacterOrientation(orientation));
                            prompt && dispatch(setSliceMotionControlTextSwitch(true));
                            const img = originalUrl || multiImage?.[0];
                            const blob = await FJFileHandleUtil.downloadImage(img);
                            const file = new File([blob], 'Image.png', { type: 'image/png' });
                            let data = await FJCompressedImageStore.compressImageByFile(file, {
                                maxPixel: 3450,
                            });
                            dispatch(
                                setSliceMotionControlImage({
                                    ...data,
                                    src: img,
                                    type: 'web',
                                }),
                            );
                            const video = videos?.[0];
                            const videoBlob = await FJFileHandleUtil.downloadVideo(video);
                            const videoFile = new File([videoBlob], 'Video.mp4', { type: 'video/mp4' });
                            const videoInfo = await FJVideoUtil.loadVideo(videoFile);
                            const ext = file.name.split('.').pop();
                            if (videoInfo) {
                                dispatch(
                                    setSliceMotionControlVideo({
                                        ...videoInfo,
                                        end: videoInfo.duration,
                                        type: 'web',
                                        mediaType: 'VIDEO',
                                        src: video,
                                        ext,
                                    }),
                                );
                            }
                        } else if (currentImageMode === IMAGE_UPLOAD_MODES.SINGLE) {
                            const _singleImage =
                                currentModel.mode === IMAGE_UPLOAD_MODES.START_END ? startImage : image;
                            const blob = await FJFileHandleUtil.downloadImage(_singleImage);
                            const file = new File([blob], 'Image.png', { type: 'image/png' });
                            await dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                        } else if (currentImageMode === IMAGE_UPLOAD_MODES.START_END) {
                            const startBlob = await FJFileHandleUtil.downloadImage(startImage);
                            const startFile = new File([startBlob], 'StartImage.png', { type: 'image/png' });
                            await dispatch(this.uploadFileAction(startFile, 0, { skipTranscoded: true }));

                            const endBlob = await FJFileHandleUtil.downloadImage(endImage);
                            const endFile = new File([endBlob], 'EndImage.png', { type: 'image/png' });
                            await dispatch(this.uploadFileAction(endFile, 1, { skipTranscoded: true }));
                        } else if (currentImageMode === IMAGE_UPLOAD_MODES.MULTI) {
                            for (let i = 0; i < multiImage.length; i++) {
                                const blob = await FJFileHandleUtil.downloadImage(multiImage[i]);
                                const file = new File([blob], `Image${i}.png`, { type: 'image/png' });
                                await dispatch(this.uploadFileAction(file, i, { skipTranscoded: true }));
                            }
                        } else {
                            const blob = await FJFileHandleUtil.downloadImage(originalUrl);
                            const file = new File([blob], 'Image.png', { type: 'image/png' });
                            await dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                        }
                        dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    } catch (error) {
                        dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                    }
                }
            }
        };
    },
    /**
     * @description 初始化video effect的预设
     * @returns {(function(*): Promise<*>)|*}
     * @private
     */
    _initVideoEffectAction: function () {
        return async dispatch => {
            // styleList 现在使用 FJVideoEffectData.js 中的常量，不再从 JSON 文件加载
            const response = await fetch(FJConfig.videoEffectPresetPath);
            const videoEffectPresetList = await response.json();
            dispatch(setSliceVideoEffectPresetList(videoEffectPresetList));
            const danceResponse = await fetch(FJConfig.videoEffectDancePresetPath);
            const videoEffectDancePresetList = await danceResponse.json();
            dispatch(setSliceDancePresetList(videoEffectDancePresetList));
        };
    },

    retryTaskAction: function (id) {
        return async (dispatch, getState) => {
            const state = getState();
            const historyList = state.common.historyList;
            let itemInfo = null;

            // 如果有id，尝试从history list中查找失败任务
            if (id) {
                itemInfo = historyList.find(item => item.status === 'failed' && item.id === id);
            }

            // 如果从history list中找不到失败任务，使用store中保存的currentSubmitParams作为备选方案
            if (!itemInfo) {
                const currentParams = state.AIVideoGenerator.currentSubmitParams;
                if (currentParams.generation_type) {
                    // 构造一个临时的itemInfo对象
                    itemInfo = {
                        generationType: currentParams.generation_type,
                        aspectRatio: currentParams.ratio,
                        duration: currentParams.duration,
                        modelType: currentParams.model_type,
                        originalUrl: currentParams.image || currentParams.start_image,
                        prompt: currentParams.prompt,
                        currentImageMode: currentParams.current_image_mode,
                        multiImage: currentParams.multi_image || [],
                        startImage: currentParams.start_image,
                        endImage: currentParams.end_image,
                        image: currentParams.image,
                        is_dubbing: currentParams.is_dubbing,
                        audio_prompt: currentParams.audio_prompt,
                        waterfall_ratio: currentParams.waterfall_ratio,
                        source: currentParams.source,
                        eventId: currentParams.event_id,
                        resolution: currentParams.resolution,
                        orientation: currentParams.orientation,
                        videos: currentParams.videos,
                    };
                }
            }

            if (itemInfo) {
                let {
                    generationType,
                    aspectRatio,
                    duration,
                    modelType,
                    originalUrl,
                    prompt,
                    currentImageMode,
                    multiImage,
                    startImage,
                    endImage,
                    image,
                    is_dubbing,
                    resolution,
                    errorCode,
                    orientation,
                    videos,
                } = itemInfo;
                image = image || originalUrl;
                const tabIndex =
                    generationType === 'tv'
                        ? AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO
                        : generationType === 'iv'
                            ? AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO
                            : AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO;

                dispatch(this.changeTabIndexAction(tabIndex));
                dispatch(setSliceRetryLoadingIds([id]));
                // 更新音效相关状态
                dispatch(setSliceAudioActive(!!is_dubbing));

                // 更新store中的currentSubmitParams，确保重试时参数准确
                const updatedParams = {
                    event_id: itemInfo.eventId || '',
                    generation_type: generationType,
                    model_type: modelType,
                    prompt: prompt,
                    duration: duration,
                    ratio: aspectRatio,
                    current_image_mode: currentImageMode,
                    start_image: startImage,
                    end_image: endImage,
                    image: image,
                    multi_image: multiImage,
                    // 添加音效相关参数
                    is_dubbing: itemInfo.is_dubbing || 0,
                    audio_prompt: itemInfo.audio_prompt || '',
                    waterfall_ratio: itemInfo.waterfall_ratio || 0,
                    // 添加来源参数
                    source: itemInfo.source || 1,
                    resolution: resolution,
                    orientation: orientation,
                    videos: videos,
                };
                dispatch(setSliceCurrentSubmitParams(updatedParams));

                if (
                    tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO ||
                    tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO
                ) {
                    dispatch(this.changeRatioAction(aspectRatio));
                    dispatch(this.changeDurationAction(duration));
                    const currentModel = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === modelType);
                    dispatch(this.changeModelAction(currentModel));
                    if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO) {
                        dispatch(setSliceTVTextValue(prompt));
                    } else if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO) {
                        dispatch(setSliceIVTextValue(prompt));
                        dispatch(setSliceImageMode(currentImageMode));

                        try {
                            if (currentModel.value === MODEL_VALUE_MAP.KLING_V26_MOTION_CONTROL) {
                                orientation && dispatch(setSliceCurCharacterOrientation(orientation));
                                prompt && dispatch(setSliceMotionControlTextSwitch(true));

                                const img = originalUrl || multiImage?.[0];
                                const blob = await FJFileHandleUtil.downloadImage(img);
                                const file = new File([blob], 'Image.png', { type: 'image/png' });
                                let data = await FJCompressedImageStore.compressImageByFile(file, {
                                    maxPixel: 3450,
                                });
                                dispatch(
                                    setSliceMotionControlImage({
                                        ...data,
                                        src: img,
                                        type: 'web',
                                    }),
                                );
                                const video = videos?.[0];
                                const videoBlob = await FJFileHandleUtil.downloadVideo(video);
                                const videoFile = new File([videoBlob], 'Video.mp4', { type: 'video/mp4' });
                                const videoInfo = await FJVideoUtil.loadVideo(videoFile);
                                const ext = file.name.split('.').pop();
                                if (videoInfo) {
                                    dispatch(
                                        setSliceMotionControlVideo({
                                            ...videoInfo,
                                            end: videoInfo.duration,
                                            type: 'web',
                                            mediaType: 'VIDEO',
                                            src: video,
                                            ext,
                                        }),
                                    );
                                }
                            } else if (currentImageMode === IMAGE_UPLOAD_MODES.SINGLE) {
                                const _singleImage =
                                    currentModel.mode === IMAGE_UPLOAD_MODES.START_END ? startImage : image;
                                const blob = await FJFileHandleUtil.downloadImage(_singleImage);
                                const file = new File([blob], 'Image.png', { type: 'image/png' });
                                await dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                            } else if (currentImageMode === IMAGE_UPLOAD_MODES.START_END) {
                                const startBlob = await FJFileHandleUtil.downloadImage(startImage);
                                const startFile = new File([startBlob], 'StartImage.png', { type: 'image/png' });
                                await dispatch(this.uploadFileAction(startFile, 0, { skipTranscoded: true }));

                                const endBlob = await FJFileHandleUtil.downloadImage(endImage);
                                const endFile = new File([endBlob], 'EndImage.png', { type: 'image/png' });
                                await dispatch(this.uploadFileAction(endFile, 1, { skipTranscoded: true }));
                            } else if (currentImageMode === IMAGE_UPLOAD_MODES.MULTI) {
                                for (let i = 0; i < multiImage.length; i++) {
                                    const blob = await FJFileHandleUtil.downloadImage(multiImage[i]);
                                    const file = new File([blob], `Image${i}.png`, { type: 'image/png' });
                                    await dispatch(this.uploadFileAction(file, i, { skipTranscoded: true }));
                                }
                            } else {
                                const blob = await FJFileHandleUtil.downloadImage(originalUrl);
                                const file = new File([blob], 'Image.png', { type: 'image/png' });
                                await dispatch(this.uploadFileAction(file, 0, { skipTranscoded: true }));
                            }
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                        } catch (error) {
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                        }
                    }
                } else {
                    const { effectInfo } = itemInfo;
                    const { effectOriginalUrlList, effect_input_video_url } = effectInfo;
                    if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO) {
                        dispatch(setSliceEVTextValue(prompt));

                        const videoEffectStyleItem = VIDEO_EFFECT_STYLE_LIST.find(
                            item => item.category === effectInfo.effect_scene,
                        );
                        if (videoEffectStyleItem) {
                            dispatch(setVideoEffectStyleSelectId(videoEffectStyleItem.key));
                        }

                        const useList = [];
                        for (let i = 0; i < effectOriginalUrlList.length; i++) {
                            const item = effectOriginalUrlList[i];
                            const { width, height } = await FJImageStore.getImageInfo(item);
                            useList.push({
                                src: item,
                                width,
                                height,
                            });
                        }
                        if (effect_input_video_url) {
                            const file = await FJUtil.getBlobByUrl(effect_input_video_url);
                            const videoInfo = await FJVideoUtil.loadVideo(file);
                            const ext = effect_input_video_url.split('.').pop();

                            if (videoInfo) {
                                dispatch(
                                    this.updateVideoEffectUploadVideoInfoAction({
                                        ...videoInfo,
                                        src: effect_input_video_url,
                                        originalUrl: effect_input_video_url,
                                        end: videoInfo.duration,
                                        type: 'web',
                                        mediaType: 'VIDEO',
                                        source: FJConstant.AI_VIDEO_S3,
                                        ext,
                                    }),
                                );
                            }
                        }

                        if (effectOriginalUrlList.length > 1) {
                            dispatch(this.setSliceVideoEffectUploadTwoImageInfoAction(useList));
                        } else {
                            dispatch(this.setSliceVideoEffectUploadImageInfoAction({ ...useList[0] }));
                        }

                        if (videoEffectStyleItem.list.length > 1) {
                            setTimeout(() => {
                                dispatch(
                                    this.changeVideoEffectImageTypeIndexAction(
                                        effectOriginalUrlList.length > 1 ? 0 : 1,
                                    ),
                                );
                            }, 200);
                        }
                    }
                }

                dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
                dispatch(setSliceRetryLoadingIds([]));
                if (errorCode !== 423 && errorCode !== 424 && errorCode !== 425) {
                    const _createTaskSuccess = async () => {
                        const result = await FJNetworkStore.deleteTaskList([id]);
                        const { code } = result;
                        if (code === 200) {
                            // 删除成功
                        } else if (code === 214) {
                            FJUtil.login();
                        } else {
                            FJMessageStore.addMessage(FJLocalStore._('failed-to-delete-please-try-again'), 'error');
                        }
                    };
                    if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO) {
                        dispatch(this.onGenerateVideoEffectAction(_createTaskSuccess));
                    } else {
                        dispatch(this.onGenerateAction(_createTaskSuccess));
                    }
                }
            }
        };
    },

    /**
     * 初始化灵感列表
     * @returns
     */
    _initInspireListAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.inspireListJsonPath);
            const inspireList = await response.json();
            dispatch(setSliceInspireList(inspireList));
        };
    },

    _initPresetAIVideoAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.presetListJsonPath);
            const { tvList, ivList } = await response.json();

            const getRandomIndexes = (length, count) => {
                const indexes = [];
                while (indexes.length < count) {
                    const randomIndex = Math.floor(Math.random() * length);
                    if (!indexes.includes(randomIndex)) {
                        indexes.push(randomIndex);
                    }
                }
                return indexes;
            };

            const allCount = 3;

            const imgVideoCount = Math.random() < 0.5 ? 2 : 1;
            const textVideoCount = allCount - imgVideoCount;

            const randomImgVideoIndexes = getRandomIndexes(ivList.length, imgVideoCount);
            const randomTextVideoIndexes = getRandomIndexes(tvList.length, textVideoCount);

            const curImgVideoPresetList = randomImgVideoIndexes.map(index => {
                return {
                    imageUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${ivList[index].imageUrl}`.replace(
                        '.webp',
                        '.png',
                    ),
                    videoUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${ivList[index].videoUrl}`,
                    smallImageUrl:
                        `${FJConfig.serverPath}${FJConfig.presetPreviewPath}small/${ivList[index].imageUrl}`.replace(
                            '.webp',
                            '.png',
                        ),
                    prompt: ivList[index].prompt,
                    type: 'image',
                };
            });

            const curTextVideoPresetList = randomTextVideoIndexes.map(index => {
                return {
                    imageUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${tvList[index].imageUrl}`.replace(
                        '.webp',
                        '.png',
                    ),
                    videoUrl: `${FJConfig.serverPath}${FJConfig.presetPreviewPath}${tvList[index].videoUrl}`,
                    prompt: tvList[index].prompt,
                    type: 'text',
                };
            });

            const curList =
                imgVideoCount === 2
                    ? [...curImgVideoPresetList, ...curTextVideoPresetList]
                    : [...curTextVideoPresetList, ...curImgVideoPresetList];

            dispatch(setSlicePresetList([...curList]));
        };
    },

    getInspireAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const inspireList = state.AIVideoGenerator.inspireList;

            if (!inspireList) {
                return;
            }

            const curLang = FJLocalStore.currentTag();
            const inspireListByLang = inspireList[curLang] || inspireList['en'];
            const curPrompt = getState().AIVideoGenerator.tvTextValue;

            const __getRandomInspire = () => {
                const randomIndex = Math.floor(Math.random() * inspireListByLang.length);

                if (inspireListByLang[randomIndex] === curPrompt) {
                    return __getRandomInspire();
                }
                return inspireListByLang[randomIndex];
            };

            const prompt = __getRandomInspire();

            dispatch(this.changeTextValueAction(prompt));
        };
    },

    onClickUsePromptAction: function (info) {
        return async dispatch => {
            const {
                imageUrl,
                prompt,
                type,
                startImageUrl,
                endImageUrl,
                multiImagesUrl,
                imageMode = IMAGE_UPLOAD_MODES.SINGLE,
            } = info;
            // todo 缺视频特效
            dispatch(
                this.changeTabIndexAction(
                    type === 'text'
                        ? AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO
                        : AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
                ),
            );

            if (type === 'image') {
                switch (imageMode) {
                    case IMAGE_UPLOAD_MODES.SINGLE:
                        try {
                            dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
                            // 下载资源到本地
                            dispatch(this.changeModelAction(AI_VIDEO_GENERATION_MODEL_LIST[1]));
                            const blob = await FJFileHandleUtil.downloadImage(imageUrl);
                            const imgBlob = new File([blob], 'Image.png', { type: 'image/png' });
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                            dispatch(this.uploadFileAction(imgBlob, 0, { skipTranscoded: true }));
                        } catch (e) {
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                        }
                        break;
                    case IMAGE_UPLOAD_MODES.START_END:
                        try {
                            dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
                            // 下载资源到本地
                            dispatch(this.changeModelAction(AI_VIDEO_GENERATION_MODEL_LIST[1]));

                            const startBlob = await FJFileHandleUtil.downloadImage(startImageUrl);
                            const startImgBlob = new File([startBlob], 'Image.png', { type: 'image/png' });
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                            dispatch(this.uploadFileAction(startImgBlob, 0, { skipTranscoded: true }));

                            const endBlob = await FJFileHandleUtil.downloadImage(endImageUrl);
                            const endImgBlob = new File([endBlob], 'Image.png', { type: 'image/png' });
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                            dispatch(this.uploadFileAction(endImgBlob, 1, { skipTranscoded: true }));

                            dispatch(this.changeImageModeAction(IMAGE_UPLOAD_MODES.START_END));
                        } catch (e) {
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                        }
                        break;
                    case IMAGE_UPLOAD_MODES.MULTI:
                        try {
                            dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
                            // 下载资源到本地
                            dispatch(
                                this.changeModelAction(
                                    AI_VIDEO_GENERATION_MODEL_LIST.find(
                                        item => item.value === MODEL_VALUE_MAP.KLING_16_STANDARD_SUBJECT,
                                    ),
                                ),
                            );
                            multiImagesUrl?.forEach(async (_imageUrl, index) => {
                                const blob = await FJFileHandleUtil.downloadImage(_imageUrl);
                                const imgBlob = new File([blob], 'Image.png', { type: 'image/png' });
                                dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                                dispatch(this.uploadFileAction(imgBlob, index, { skipTranscoded: true }));
                            });

                            dispatch(this.changeImageModeAction(IMAGE_UPLOAD_MODES.MULTI));
                        } catch (e) {
                            dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                        }
                        break;
                }

                prompt && dispatch(setSliceIVTextValue(prompt));
            } else {
                prompt && dispatch(setSliceTVTextValue(prompt));
            }
        };
    },

    setCurrentGenerateStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceCurrentGenerateStatus(status));
        };
    },

    setCurrentTackIdAction: function (id) {
        return dispatch => {
            dispatch(setSliceCurrentTackId(id));
        };
    },

    setGeneratingVideoNumAction: function (num) {
        return dispatch => {
            dispatch(setSliceGeneratingVideoNum(num));
        };
    },

    setIsShowGeneratingVideoNumAction: function (bool) {
        return dispatch => {
            dispatch(setSliceIsShowGeneratingVideoNum(bool));
        };
    },

    useAIImageAction: function (info, index) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIVideoGenerator.uploadStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            try {
                dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
                const blob = await FJFileHandleUtil.downloadImage(info.imgUrl);
                const imgBlob = new File([blob], 'Image.png', { type: 'image/png' });
                dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
                dispatch(this.uploadFileAction(imgBlob, index, { skipTranscoded: true }));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
            }

            // const source = curMenuIndex === 0 ? FJConstant.AI_VIDEO_TEXT_IMAGE_S3 : FJConstant.AI_VIDEO_IMAGE_IMAGE_S3;
            // dispatch(this.changeUploadStatusAction(FJConstant.LOADING));
            // const isImageExceedSize = await FJUtil.checkImageSize(info.imgUrl);
            // if (isImageExceedSize) {
            //     FJMessageStore.addMessage(FJLocalStore._('the-image-should-be-larger-than'), 'error');
            //     dispatch(this.changeUploadStatusAction(FJConstant.DEFAULT));
            //     return;
            // }
            //
            // dispatch(this.changeUploadStatusAction(FJConstant.SUCCESS));
            // dispatch(
            //     this.changeOriginImageInfoAction({
            //         src: info.imgUrl,
            //         source: source,
            //     }),
            // );
        };
    },

    onGenerateAction: function (createTaskSuccess = () => { }) {
        return async (dispatch, getState) => {
            const state = getState();
            const tabIndex = state.AIVideoGenerator.tabIndex;
            const currentRatio = state.AIVideoGenerator.currentRatio;
            const currentQuality = state.AIVideoGenerator.currentQuality;
            const currentDuration = state.AIVideoGenerator.currentDuration;
            const originImage = state.AIVideoGenerator.originImage;
            const tvTextValue = state.AIVideoGenerator.tvTextValue;
            const ivTextValue = state.AIVideoGenerator.ivTextValue;
            const audioActive = state.AIVideoGenerator.audioActive;
            const aiSfxTotalCredit = state.AIVideoGenerator.aiSfxTotalCredit;
            const currentModel = state.AIVideoGenerator.currentModel;

            const ivPrivacyStatus = state.AIVideoGenerator.ivPrivacyStatus;
            const tvPrivacyStatus = state.AIVideoGenerator.tvPrivacyStatus;

            let uploadImages = state.AIVideoGenerator.uploadImages;
            const currentResolution = state.AIVideoGenerator.currentResolution;
            const curCharacterOrientation = state.AIVideoGenerator.curCharacterOrientation;
            const motionControlImage = state.AIVideoGenerator.motionControlImage;
            const motionControlVideo = state.AIVideoGenerator.motionControlVideo;
            const motionControlTextSwitch = state.AIVideoGenerator.motionControlTextSwitch;
            const isMotionControl = currentModel === MODEL_VALUE_MAP.KLING_V26_MOTION_CONTROL;

            const params = {
                prompt: '',
                generationType: '',
            };
            if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO) {
                params.prompt = ivTextValue;
                params.generationType = 'iv';
                if (isMotionControl && !motionControlTextSwitch) {
                    params.prompt = '';
                }
            } else if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO) {
                params.prompt = tvTextValue;
                params.generationType = 'tv';
            }

            const currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(model => model.value === currentModel);
            const creditPrice =
                currentModelConfig.creditPriceLevels?.[currentResolution] || currentModelConfig.creditPrice;
            const totalCredit = creditPrice * currentDuration;

            uploadImages = getState().AIVideoGenerator.uploadImages;
            const data = {
                originImage: originImage,
                modelType: currentQuality === 1 ? 'standard' : 'v1.5',
                duration: currentDuration,
                ratio: currentRatio,
                totalCredit: totalCredit + aiSfxTotalCredit,
                tabIndex,
                audioActive,
                currentModel,
                uploadImages,
                resolution: currentResolution,
                ...params,
                createTaskSuccess,
                ivPrivacyStatus,
                tvPrivacyStatus,
                curCharacterOrientation,
                motionControlImage,
                motionControlVideo,
                isMotionControl,
            };

            dispatch(this._onGenerateAction(data));
        };
    },

    /**
     * @description 视频特效的生成
     * @returns {(function(*, *): Promise<void>)|*}
     */
    onGenerateVideoEffectAction: function (createTaskSuccess = () => { }) {
        return async (dispatch, getState) => {
            const state = getState();
            const tabIndex = state.AIVideoGenerator.tabIndex; // 选择的tab页
            if (tabIndex !== AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO) return;
            const videoEffectCredit = state.AIVideoGenerator.videoEffectCredit; // 视频特效消耗的积分
            const creditNumber = state.common.creditNumber; // 总共的积分
            const evPrivacyStatus = state.AIVideoGenerator.evPrivacyStatus;

            FJUtil.eaLog('ai videos generate click', {
                type: FJEaLogDataUtil.getVideoGeneratorType(tabIndex),
            });

            const {
                videoEffectUploadTwoImageInfo,
                videoEffectUploadImageInfo,
                videoEffectUploadVideoInfo,
                evTextValue,
                imageTypeIndex,
                videoEffectStyleSelectId,
            } = state.AIVideoGenerator;

            let imgList = [];
            let videoList = [];
            let genType = '';
            let genPrompt = '';
            let ratio = '';
            // 判断上传是否是两种模式
            const currentItem = VIDEO_EFFECT_STYLE_LIST.find(item => item.key === videoEffectStyleSelectId);
            // 上传是否是两种模式
            if (currentItem.list.length === 2) {
                genType = currentItem.list[imageTypeIndex].type;
                genPrompt = currentItem.list[imageTypeIndex].preset_prompt;
                if (imageTypeIndex === 0) {
                    // 双图模式
                    imgList = videoEffectUploadTwoImageInfo;
                } else {
                    // 单图
                    imgList.push({ ...videoEffectUploadImageInfo });
                }
            } else {
                const itemList = currentItem.list[0];
                genType = itemList.type;
                genPrompt = itemList.preset_prompt;
                if (itemList.imgType === 'DOUBLE') {
                    // 双图模式
                    imgList = videoEffectUploadTwoImageInfo;
                } else if (itemList.imgType === 'VIDEO_AND_PIC') {
                    videoEffectUploadVideoInfo.src && videoList.push({ ...videoEffectUploadVideoInfo });
                    imgList.push({ ...videoEffectUploadImageInfo });
                } else {
                    // 单图
                    imgList.push({ ...videoEffectUploadImageInfo });
                }
            }

            // 对file进行判断
            let isExitFile = true;
            imgList.forEach(item => {
                if (!item.src) {
                    isExitFile = false;
                }
            });

            if (!isExitFile) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }
            if (
                currentItem.list[0].imgType === 'VIDEO_AND_PIC' &&
                (videoList.length == 0 || !videoList[0].src || imgList.length == 0)
            ) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-files-first'), 'error');
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }
            if (
                currentItem.key === 'dancing' ||
                currentItem.key === 'mimic-motion' ||
                currentItem.key === 'character-swap'
            ) {
                const { width, height } = imgList[0];
                if (
                    Math.min(width, height) < 300 ||
                    Math.max(width, height) > 4096 ||
                    Math.max(width, height) / Math.min(width, height) > 3
                ) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('the-aspect-ratio-of-the-image-should-be-between-13-and-31'),
                        'error',
                    );
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
            }

            //  切换右侧tab，置为开始状态
            dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            /**
             * 检查用户状态
             * @type {number}
             */
            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    dispatch(this.generateErrorAction(true, { isVideoEffectError: true }));
                },
            });
            // 用户状态有问题
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }
            /**
             * 生成的积分大于总的积分；没有免费的次数
             */
            if (videoEffectCredit > creditNumber) {
                dispatch(FJActionModal.showUpgradeModalAction());
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            const imgURLList = [];
            const videoURLList = [];
            // 上传图片到s3
            try {
                for (let i = 0; i < imgList.length; i++) {
                    const imgItem = imgList[i];

                    if (imgItem.type === 'local') {
                        const file = await FJUtil.getBlobByUrl(imgItem?.src);
                        const id = await FJUtil.hashEncode(file);
                        const key = FJConfig.originalImageKey + `${id}.png`;
                        const result = await FJImageStore.upLoadFileToS3Async(file, key);
                        if (result) {
                            imgURLList.push(FJS3Config.S3_SERVER_HOST + key);
                        } else {
                            dispatch(this.generateErrorAction(true, { isVideoEffectError: true }));
                            return;
                        }
                    } else {
                        imgURLList.push(imgItem?.src);
                    }

                    if (i === 0) {
                        // Constants for standard ratios
                        const STANDARD_RATIOS = {
                            '16:9': 16 / 9, // 1.778
                            '9:16': 9 / 16, // 0.5625
                            '1:1': 1,
                        };
                        // Convert raw ratio to closest standard ratio
                        const _convertToStandardRatio = rawRatio => {
                            let closestRatio = '1:1';
                            let minDiff = Math.abs(rawRatio - STANDARD_RATIOS['1:1']);

                            Object.entries(STANDARD_RATIOS).forEach(([ratioStr, ratioVal]) => {
                                const diff = Math.abs(rawRatio - ratioVal);
                                if (diff < minDiff) {
                                    minDiff = diff;
                                    closestRatio = ratioStr;
                                }
                            });

                            return closestRatio;
                        };
                        try {
                            const rawRatio = await FJImageStore.getImageRatio(imgURLList[0]);

                            ratio = _convertToStandardRatio(rawRatio);
                        } catch (e) {
                            const imgUrl = imgURLList[0] + `?v=${new Date().getTime()}`;
                            const rawRatio = await FJImageStore.getImageRatio(imgUrl);
                            ratio = _convertToStandardRatio(rawRatio);
                        }
                    }
                }
                for (let i = 0; i < videoList.length; i++) {
                    const videoItem = videoList[i];

                    if (videoItem.type === 'local') {
                        const file = await FJUtil.getBlobByUrl(videoItem?.src);
                        const id = await FJUtil.hashEncode(file);
                        const key = FJConfig.originalImageKey + `${id}.${videoItem.ext}`;
                        const result = await FJImageStore.upLoadFileToS3Async(file, key);
                        if (result) {
                            videoURLList.push(FJS3Config.S3_SERVER_HOST + key);
                        } else {
                            dispatch(this.generateErrorAction(true, { isVideoEffectError: true }));
                            return;
                        }
                    } else {
                        videoURLList.push(videoItem?.originalUrl);
                    }
                }
            } catch (e) {
                dispatch(this.generateErrorAction(true, { isVideoEffectError: true }));
                return;
            }

            let usePrompt = genPrompt ? genPrompt : '' + evTextValue;
            // 生成描述
            const needGeneratorPromptList = ['ghibli-2', 'felt'];
            if (needGeneratorPromptList.indexOf(currentItem.category) !== -1 && !evTextValue) {
                try {
                    const promptResult = await FJNetworkStore.getChatData({
                        stream: 0,
                        type: 10,
                        image: imgURLList.join(','),
                    });
                    if (promptResult) {
                        usePrompt = JSON.parse(promptResult).text;
                    }
                } catch (e) {
                    console.error(e);
                }
            }

            // AI生成视频
            const _request = async () => {
                const useOptions = {
                    styleId: currentItem.category,
                    prompt: usePrompt,
                    imageUrl: imgURLList.join(','),
                    videoUrl: videoURLList.join(','),
                    ratio: ratio,
                    privacyStatus: evPrivacyStatus,
                };
                return await FJNetworkStore.videoEffectGeneration(genType, useOptions);
            };
            try {
                //  创建任务
                const currentTaskId = await FJActionCommon.createRequestTask(_request, dispatch);
                if (!currentTaskId) {
                    dispatch(this.generateErrorAction(true, { isVideoEffectError: true }));
                    return;
                }
                FJUtil.eaLog('ai generate community privacy settings', {
                    setting: evPrivacyStatus,
                });
                // 后台更新积分
                FJUtil.updateAllCreditInfo(false);
                await createTaskSuccess();
                FJUtil.eaLog('ai_video_effect_success_type', {
                    type: videoEffectStyleSelectId.replaceAll('-', ' '),
                });

                dispatch(this.setCurrentGenerateStatusAction(FJConstant.RUNNING));
                dispatch(this.setCurrentTackIdAction(currentTaskId));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(FJActionCommon.updateHistoryListAction());
            } catch (e) {
                dispatch(this.generateErrorAction(undefined, { isVideoEffectError: true }));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },

    _onGenerateAction: function (data) {
        return async (dispatch, getState) => {
            dispatch(setSliceTaskStatusAction(FJConstant.START));

            const state = getState();
            const {
                originImage,
                generationType,
                prompt,
                duration,
                totalCredit,
                ratio: _ratio,
                tabIndex,
                audioActive,
                currentModel,
                uploadImages,
                resolution,
                createTaskSuccess,
                tvPrivacyStatus,
                ivPrivacyStatus,
                curCharacterOrientation,
                motionControlVideo,
                motionControlImage,
                isMotionControl,
            } = data;
            const tabsData = {
                freeNumCreation: 0,
                source: 1,
                type: 'image to video',
            };
            const creditNumber = state.common.creditNumber;
            const { ivFreeNum, tvFreeNum, imageMode: currentImageMode } = state.AIVideoGenerator;
            const currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === currentModel);
            const { mode, promptRequired, promptCharacterLimit } = currentModelConfig;
            let ratio = _ratio;

            let privacyStatus = null;

            if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO) {
                privacyStatus = ivPrivacyStatus;
                tabsData.freeNumCreation = ivFreeNum;
                tabsData.source = originImage?.source;
                tabsData.type = 'image to video';
                // 如果ratio为空，则计算图片的宽高比， 如果当前模型在需要预设比例的模型列表中，则使用预设比例，否则使用图片的宽高比
                ratio = currentModelConfig.supportImageSelectRatio
                    ? _ratio
                    : FJRequirementsUtil.calculateAspectRatio(uploadImages[0]?.width, uploadImages[0]?.height);
            } else if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO) {
                tabsData.freeNumCreation = tvFreeNum;
                tabsData.source = 1;
                tabsData.type = 'text to video';
                privacyStatus = tvPrivacyStatus;
            }
            let { freeNumCreation, source, type } = tabsData;
            let waterfallRatio = 0;
            FJUtil.eaLog('ai videos generate click', {
                mode: currentModel,
                ratio: ratio,
                duration: duration,
                resolution: resolution,
                type:
                    currentImageMode === IMAGE_UPLOAD_MODES.MULTI
                        ? 'subject reference'
                        : currentImageMode === IMAGE_UPLOAD_MODES.START_END
                            ? 'first and last frames'
                            : type,
                ABtest_model_select: FJUtil.getABTest() ? 'list' : 'window',
            });

            /**
             * 切换右侧tab
             */
            dispatch(FJActionCommon.setHeaderTabIndexAction(FJConstant.CREATIONS));

            // 判断是否需要上传图片到s3
            let imgUrl = uploadImages[0]?.src;
            let startImageUrl = uploadImages[0]?.src;
            let endImageUrl = uploadImages[1]?.src;
            let multiImagesUrl = [];
            let audioPrompt = '';
            let videoUrl = null;
            if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO) {
                //#region 1. 前端校验用户输入
                if (isMotionControl) {
                    if (!motionControlImage?.src) {
                        FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                        return;
                    }
                    if (!motionControlVideo?.src) {
                        FJMessageStore.addMessage(FJLocalStore._('please-upload-files-first'), 'error');
                        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                        return;
                    }
                }
                if (!uploadImages[0]?.src && !isMotionControl) {
                    FJMessageStore.addMessage(FJLocalStore._('please-upload-an-image-first'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                const _prompt = prompt.replace(/\s/g, '');
                if (promptRequired && (_prompt.length === 0 || prompt.length === 0)) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                if (prompt.length > promptCharacterLimit || _prompt.length > promptCharacterLimit) {
                    FJMessageStore.addMessage(FJLocalStore._('the-prompt-is-too-long-please-shorten-it'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                if (
                    !isMotionControl &&
                    (!_judgeDouBaoImageValidate(currentModel, uploadImages[0]) ||
                        (endImageUrl && !_judgeDouBaoImageValidate(currentModel, uploadImages[1])))
                ) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-image-ratio-please-upload-a-new-file'),
                        'error',
                    );
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                //#endregion

                //#region 2. 检查用户状态
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        dispatch(this.generateErrorAction(true));
                    },
                });
                // 错误
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                //#endregion

                //#region 3. 积分的判断
                if (totalCredit > creditNumber && (freeNumCreation === 0 || totalCredit > 11.5)) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                //#endregion

                //#region 4. 上传图片到s3，处理音效
                const _uploadFileAndCompressed = async (fileInfo, ext = 'png') => {
                    let res = fileInfo.src;
                    if (fileInfo.type === 'local') {
                        const file = await FJUtil.getBlobByUrl(res);
                        const id = await FJUtil.hashEncode(file);
                        const key = FJConfig.originalImageKey + `${id}.${ext}`;
                        const result = await FJImageStore.upLoadFileToS3Async(file, key);
                        if (result) {
                            res = FJS3Config.S3_SERVER_HOST + key;
                        } else {
                            dispatch(this.generateErrorAction(true));
                            return;
                        }
                        source = 1;
                    }
                    return res;
                };

                try {
                    if (isMotionControl) {
                        imgUrl = await _uploadFileAndCompressed(motionControlImage);
                        videoUrl = await _uploadFileAndCompressed(motionControlVideo, motionControlVideo.ext || 'mp4');
                    } else if (mode === IMAGE_UPLOAD_MODES.SINGLE) {
                        // 单图模式处理
                        imgUrl = await _uploadFileAndCompressed(uploadImages[0]);

                        waterfallRatio = await _getWaterfallRatio(imgUrl, ratio, currentModel);
                    } else if (mode === IMAGE_UPLOAD_MODES.START_END) {
                        // 首尾帧模式处理

                        // 上传开始图片
                        startImageUrl = await _uploadFileAndCompressed(uploadImages[0]);

                        // 上传结束图片（如果存在）
                        endImageUrl && (endImageUrl = await _uploadFileAndCompressed(uploadImages[1]));

                        imgUrl = startImageUrl; // 主图片URL设置为开始图片

                        // 获取开始图片的比例
                        waterfallRatio = await _getWaterfallRatio(startImageUrl, ratio, currentModel);
                        source = 1;
                    } else if (mode === IMAGE_UPLOAD_MODES.MULTI) {
                        // 多图模式处理

                        for (let i = 0; i < uploadImages.length; i++) {
                            const image = uploadImages[i];
                            if (!image?.src) continue;

                            let imageUrl = await _uploadFileAndCompressed(image);
                            multiImagesUrl[i] = imageUrl;
                        }

                        imgUrl = multiImagesUrl[0]; // 主图片URL设置为第一张图片
                        // 获取第一张图片的比例
                        waterfallRatio = await _getWaterfallRatio(multiImagesUrl[0], ratio, currentModel);
                        source = 1;
                    }

                    // 音效处理（对所有模式通用）
                    if (audioActive) {
                        const simpleImageUrl = await FJImageStore.upLoadFileToS3ByUrl(imgUrl, {
                            isCompress: true,
                            maxWidth: 400,
                            maxHeight: 400,
                        });
                        const { data, code } = await FJNetworkStore.generateImageByPromptInAiSfx(simpleImageUrl, 'en');
                        if (code === 200) {
                            audioPrompt = data.prompt;
                        }
                    }
                } catch (e) {
                    dispatch(this.generateErrorAction(true));
                    return;
                }
                //#endregion
            } else if (tabIndex === AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO) {
                imgUrl = null;
                waterfallRatio = await _getWaterfallRatio(imgUrl, ratio, currentModel);

                //#region 1. 前端校验 prompt
                const _prompt = prompt.replace(/\s/g, '');
                if (_prompt.length === 0 || prompt.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                if (prompt.length > promptCharacterLimit || _prompt.length > promptCharacterLimit) {
                    FJMessageStore.addMessage(FJLocalStore._('the-prompt-is-too-long-please-shorten-it'), 'error');
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                //#endregion

                //#region 2. 检查用户状态
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        dispatch(this.generateErrorAction(true));
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                //#endregion

                //#region 3. 积分的判断
                if (totalCredit > creditNumber && (freeNumCreation === 0 || totalCredit > 10)) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                    return;
                }
                //#endregion

                //#region 4. 是否添加音效
                if (audioActive) {
                    try {
                        audioPrompt = await FJStringUtil.translatePrompt(prompt);
                    } catch (e) {
                        dispatch(this.generateErrorAction(true));
                        return;
                    }
                }
                //#endregion
            }

            const tool = FJUtil.getToolName();
            const canFreeCreate = freeNumCreation > 0;
            const isFree = creditNumber < totalCredit && canFreeCreate;
            FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });

            // 在创建任务之前，先更新store中的currentSubmitParams，保存当前任务参数
            const currentSubmitParams = {
                generation_type: generationType,
                model_type: currentModel,
                prompt: prompt,
                duration: duration,
                ratio: ratio,
                resolution: resolution,
                is_dubbing: audioActive ? 1 : 0,
                audio_prompt: audioPrompt || '',
                waterfall_ratio: waterfallRatio || 0,
                source: source,
                current_image_mode: currentImageMode,
                start_image: startImageUrl || '',
                end_image: endImageUrl || '',
                image: imgUrl || '',
                video: videoUrl || '',
                orientation: curCharacterOrientation,
                multi_image: multiImagesUrl || [],
            };
            dispatch(setSliceCurrentSubmitParams(currentSubmitParams));

            // AI生成视频
            const _request = async () => {
                const params = {
                    generationType,
                    modelType: currentModel,
                    prompt,
                    duration,
                    ratio,
                    resolution,
                    waterfallRatio,
                    source,
                    audioActive,
                    audioPrompt,
                    currentImageMode,
                    privacyStatus,
                };

                // 如果当前模型是doubao的模型，则需要将所有的图片路径替换为 https://da1mnv1i99sez.cloudfront.net/， **后端已经处理**

                if (generationType === 'iv') {
                    // 统一使用 images 格式
                    params.images = {
                        0: null,
                        1: null,
                        2: null,
                        3: null,
                    };
                    if (isMotionControl) {
                        params.images[0] = imgUrl;
                        params.videos = [videoUrl];
                        params.orientation = curCharacterOrientation;
                    } else if (mode === IMAGE_UPLOAD_MODES.MULTI) {
                        // 多图模式：将多张图片分配到不同的位置
                        multiImagesUrl.forEach((url, index) => {
                            if (index < 4) {
                                params.images[index] = url;
                            }
                        });
                    } else if (mode === IMAGE_UPLOAD_MODES.START_END) {
                        // 首尾帧模式：开始图片放在位置0，结束图片放在位置1
                        params.images[0] = startImageUrl;
                        if (currentImageMode === IMAGE_UPLOAD_MODES.START_END) {
                            params.images[1] = endImageUrl;
                        }
                    } else if (mode === IMAGE_UPLOAD_MODES.SINGLE) {
                        // 单图模式：图片放在位置0
                        params.images[0] = imgUrl;
                    }
                }

                return await FJNetworkStore.videoGenerationV2({
                    ...params,
                });
            };
            try {
                // 创建任务
                const currentTaskId = await FJActionCommon.createRequestTask(_request, dispatch);
                FJUtil.eaLog('ai generate community privacy settings', {
                    setting: privacyStatus,
                });
                if (!currentTaskId) {
                    dispatch(this.generateErrorAction(true));
                    return;
                }
                await createTaskSuccess();
                FJUtil.updateAllCreditInfo(isFree);

                if (currentModel.includes('doubao')) {
                    // doubao模型，默认等待
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.WAITING));
                } else {
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.RUNNING));
                }

                dispatch(this.setCurrentTackIdAction(currentTaskId));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                dispatch(FJActionCommon.updateHistoryListAction());
            } catch (e) {
                // 当error code 为423时，表示视频生成内容违规
                dispatch(this.generateErrorAction(undefined, { errorCode: e.cause }));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },

    checkIsShowGeneratingVideoNumAction: function () {
        return (dispatch, getState) => {
            const state = getState();
            const currentTackId = state.AIVideoGenerator.currentTackId;
            const historyList = state.common.historyList;
            const generatingTaskIdList = historyList
                // 包含progress和queued状态
                .filter(item => item.status === 'progress' || item.status === 'queued')
                .map(item => item.eventId);
            const generatingVideoNum = generatingTaskIdList.length;

            if (currentTackId) {
                const item = historyList.find(item => item.eventId === currentTackId);
                if (item.status === 'completed') {
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.SUCCESS));
                    dispatch(
                        setSliceCreationListAction([
                            {
                                originalImageUrl: item.originalUrl,
                                videoUrl: item.videoUrl,
                                coverImageUrl: item.imgUrl,
                                id: item.id,
                                ratio: item.ratio,
                                privacyStatus: item.privacyStatus,
                                shareKey: item.shareKey,
                            },
                        ]),
                    );
                    dispatch(this.setCurrentTackIdAction(null));
                } else if (item.status === 'failed') {
                    if (f_failInfo.indexOf(currentTackId) === -1) {
                        const errorCode = item.errorCode;
                        dispatch(this.generateErrorAction(undefined, { errorCode, ignoreMessage: true }));
                        f_failInfo.push(currentTackId);
                    }
                } else if (item.status === 'queued') {
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.WAITING));
                } else {
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.RUNNING));
                }
            }

            dispatch(this.setGeneratingVideoNumAction(generatingVideoNum));
            if (!f_isPolling) {
                dispatch(this.pollingVideoGeneratorTaskListAction());
            }

            // 是否首次显示
            if (!f_isFirstShowGeneratingVideoNum) {
                if (currentTackId) {
                    if (generatingTaskIdList.indexOf(currentTackId) !== -1 && generatingVideoNum > 1) {
                        dispatch(this.setIsShowGeneratingVideoNumAction(true));
                        f_isFirstShowGeneratingVideoNum = true;
                    }
                } else {
                    if (generatingVideoNum > 0) {
                        dispatch(this.setIsShowGeneratingVideoNumAction(true));
                        f_isFirstShowGeneratingVideoNum = true;
                    }
                }
            }
        };
    },

    pollingVideoGeneratorTaskListAction: function () {
        return async (dispatch, getState) => {
            f_isPolling = true;
            const _clear = () => {
                f_isPolling = false;
                if (f_timer) {
                    clearTimeout(f_timer);
                    f_timer = null;
                }
            };
            _clear();
            const state = getState();
            const historyList = state.common.historyList;
            const creationList = state.common.creationList;
            const currentTackId = state.AIVideoGenerator.currentTackId;

            const generatingTaskList = historyList.filter(
                item => item.status === 'progress' || item.status === 'queued',
            );
            const generatingTaskIdList = generatingTaskList.map(item => item.eventId);
            if (generatingTaskIdList.length === 0) {
                dispatch(this.setGeneratingVideoNumAction(0));
                dispatch(this.setIsShowGeneratingVideoNumAction(false));
                _clear();
                return;
            }

            const delayTime = TASK_POLLING_INTERVAL * 10;
            const __pollingFunc = () => {
                dispatch(this.pollingVideoGeneratorTaskListAction());
            };

            try {
                const result = await FJNetworkStore.getNewTaskState(generatingTaskIdList.join(','));
                let isStopPolling = false;
                let data = result;

                if (!data) {
                    f_errorTime++;
                    if (f_errorTime >= MAX_POLLING_ERROR_TIME) {
                        _clear();
                    } else {
                        _clear();
                        f_isPolling = true;
                        f_timer = setTimeout(__pollingFunc, delayTime);
                    }
                    return;
                }

                if (!Array.isArray(result)) {
                    // 处理数组类型的data
                    data = [result];
                }

                let failTaskCount = 0;
                let isNeedUpdate = false;
                // 是否更新且仅更新状态， waiting 和 processing 需要更新状态
                let isNeedStatusUpdate = false;
                await Promise.all(
                    data.map(async (item, index) => {
                        switch (item.job_state) {
                            case 'succeeded':
                                dispatch(FJActionEditPage.updateAIToolListFromAIToolAction());

                                try {
                                    if (item.out_put) {
                                        const {
                                            aspect_ratio,
                                            model_type,
                                            prompt,
                                            duration,
                                            generation_type,
                                            is_dubbing,
                                            effect_style,
                                        } = item.out_put[0].request_params;
                                        const currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(
                                            item => item.value === model_type,
                                        );

                                        FJUtil.eaLog('ai videos generate success', {
                                            mode: currentModelConfig.value,
                                            ratio: aspect_ratio,
                                            duration: duration,
                                            type:
                                                currentModelConfig.mode === IMAGE_UPLOAD_MODES.MULTI
                                                    ? 'subject reference'
                                                    : currentModelConfig.mode === IMAGE_UPLOAD_MODES.START_END
                                                        ? 'first and last frames'
                                                        : effect_style
                                                            ? 'video effect'
                                                            : generation_type === 'iv'
                                                                ? 'image to video'
                                                                : 'text to video',
                                            prompt: prompt,
                                            'ai sfx': is_dubbing ? 'true' : 'false',
                                        });

                                        const info = JSON.parse(item.out_put[0].info);

                                        if (is_dubbing && !info.has_dubbing) {
                                            FJMessageStore.addMessage(
                                                FJLocalStore._('dubbing-failed-please-try-again'),
                                                'error',
                                            );
                                            FJUtil.updateAllCreditInfo(false);
                                        }
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                                FJUtil.eaLog('ai tool generate success', { tool: FJUtil.getToolName() });

                                isNeedUpdate = true;
                                break;
                            case 'waiting':
                                if (
                                    item.out_put?.[0]?.request_params?.state &&
                                    item.out_put?.[0]?.request_params?.state !== generatingTaskList[index].status
                                ) {
                                    isNeedStatusUpdate = true;
                                }
                                break;
                            case 'processing':
                                if (
                                    item.out_put?.[0]?.request_params?.state &&
                                    item.out_put?.[0]?.request_params?.state !== generatingTaskList[index].status
                                ) {
                                    isNeedStatusUpdate = true;
                                }
                                break;
                            case 'canceled':
                                if (
                                    item.out_put?.[0]?.request_params?.state &&
                                    item.out_put?.[0]?.request_params?.state !== generatingTaskList[index].status
                                ) {
                                    isNeedStatusUpdate = true;
                                }
                                break;
                            case 'timeout':
                            case 'failed':
                                isNeedUpdate = true;
                                failTaskCount++;
                                if (failTaskCount === generatingTaskIdList.length) {
                                    isStopPolling = true;
                                }

                                //todo: 失败更新免费次数
                                FJUtil.updateAllCreditInfo(true);

                                break;
                            default:
                                break;
                        }
                    }),
                );
                if (isStopPolling) {
                    _clear();
                } else {
                    _clear();
                    f_isPolling = true;
                    f_timer = setTimeout(__pollingFunc, delayTime);
                }
                if (isNeedUpdate) {
                    dispatch(FJActionCommon.updateHistoryListAction(undefined, { ignoreLoading: true }));
                }
                // 更新状态
                if (isNeedStatusUpdate) {
                    dispatch(
                        setSliceHistoryListAction(
                            historyList.map(historyItem => {
                                // 从data中找到对应的任务状态
                                const index = generatingTaskIdList?.findIndex(item => item === historyItem.eventId);
                                if (index !== -1) {
                                    return { ...historyItem, status: data[index]?.out_put?.[0]?.request_params?.state };
                                }
                                return historyItem;
                            }),
                        ),
                    );
                    dispatch(
                        setSliceCreationListAction(
                            creationList.map(creationItem => {
                                const index = generatingTaskIdList?.findIndex(item => item === creationItem.id);
                                if (index !== -1) {
                                    return {
                                        ...creationItem,
                                        status: data[index]?.out_put?.[0]?.request_params?.state,
                                    };
                                }
                                return creationItem;
                            }),
                        ),
                    );
                    // 获取当前任务的最新状态
                    const currentTask = data.find(item => item.event_id === currentTackId);
                    if (currentTask) {
                        const currentTaskStatus = currentTask?.out_put?.[0]?.request_params?.state;
                        if (currentTaskStatus === 'queued') {
                            dispatch(this.setCurrentGenerateStatusAction(FJConstant.WAITING));
                        } else if (currentTaskStatus === 'progress') {
                            dispatch(this.setCurrentGenerateStatusAction(FJConstant.RUNNING));
                        }
                    }
                }
            } catch (error) {
                console.log(error);
                _clear();
                f_isPolling = false;
            }
        };
    },

    generateErrorAction: function (ignoreCurrentStatus = false, options = {}) {
        return dispatch => {
            const { isVideoEffectError = false, errorCode = null, ignoreMessage = false } = options;

            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));

            !ignoreMessage &&
                FJMessageStore.addMessage(
                    FJLocalStore._(
                        isVideoEffectError
                            ? 'generation-failed-please-try-again-or-try-other-images'
                            : 'failed-to-create-task',
                    ),
                    'error',
                );
            if (!ignoreCurrentStatus) {
                // 右侧tab状态
                dispatch(this.setCurrentGenerateStatusAction(FJConstant.ERROR));
                if (errorCode === 423) {
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.VIOLATION));
                }
                if (errorCode === 424) {
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.VIDEO_WITHOUT_PERSON));
                }
                if (errorCode === 425) {
                    dispatch(this.setCurrentGenerateStatusAction(FJConstant.IMAGE_WITHOUT_PERSON));
                }
            }
        };
    },

    updateUseFreeLimitAction: function (info) {
        return dispatch => {
            const ivFreeNum = info['image-to-video'];
            const tvFreeNum = info['text-to-video'];
            dispatch(setSliceIVFreeNumCreationAction(ivFreeNum));
            dispatch(setSliceTVFreeNumCreationAction(tvFreeNum));
        };
    },
    /**
     * 重新生成封面图
     * @param {string} id 历史记录id
     */
    regenerateCoverImageAction: function (id) {
        return async (dispatch, getState) => {
            const isOnline = await FJUtil.checkNetworkStatus();
            if (!isOnline) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
                return;
            }
            const historyList = getState().common.historyList;
            const historyItem = historyList.find(item => item.id === id);
            if (!historyItem) return;
            dispatch(
                setSliceHistoryListAction(
                    historyList.map(item => {
                        if (item.id === id) {
                            return { ...item, isLoading: true };
                        }
                        return item;
                    }),
                ),
            );
            const { code, data: imageName } = await FJNetworkStore.regenerateCoverImage({
                videoUrl: historyItem.videoUrl,
                eventId: historyItem.eventId,
            });
            let videoUrl = '';
            let imgUrl = '';
            if (code == 200 && imageName) {
                videoUrl =
                    FJS3Config.S3_SERVER_HOST +
                    FJAIVideoGeneratorConfig.resultVideoKey +
                    imageName +
                    `?v=${Date.now()}`;
                imgUrl =
                    FJS3Config.S3_SERVER_HOST +
                    FJAIVideoGeneratorConfig.resultCoverKey +
                    imageName.replace('.mp4', '.png') +
                    `?v=${Date.now()}`;
            }
            dispatch(
                setSliceHistoryListAction(
                    historyList.map(item => {
                        if (item.id === id) {
                            return { ...item, isLoading: false, imgUrl, videoUrl };
                        }
                        return item;
                    }),
                ),
            );
        };
    },

    /**
     * @desc 编辑AI配音
     * @param id
     * @param options
     * @returns {(function(*, *): Promise<void>)|*}
     */
    editAISfxAction: function (id, options = {}) {
        const { previewList: tempPreviewList } = options;
        return async (dispatch, getState) => {
            const reducerHistoryList = getState().common.historyList;
            const historyList = tempPreviewList || reducerHistoryList;
            const historyItem = historyList.find(item => item.id === id);
            if (!historyItem) return;

            FJUtil.eaLog('history preview ai sfx click');

            const data = {
                videoUrl: historyItem.videoUrl,
            };

            const __getRandomName = () => {
                // 生成随机字符串 用纯数字
                return Math.random().toString(36).substring(2, 15);
            };
            const recId = __getRandomName();

            localStorage.setItem(recId, JSON.stringify(data));
            const jumpUrl = FJHeaderConfig.aiMenuList.find(item => item.title === 'ai-video-dub').href;
            location.href = `${jumpUrl}?rec_id=${recId}`;
        };
    },

    /**
     * @description 使用视频特效预设
     * @param info
     * @returns {(function(*, *))|*}
     */
    usePresetInVideoEffectAction: function (info) {
        return async dispatch => {
            const { key, img, prompt, randomIndex } = info;
            const currentItem = VIDEO_EFFECT_STYLE_LIST.find(item => item.key === key);

            try {
                const imgUrl = FJConfig.videoEffectMediaPresetPath + randomIndex + '/' + img + '.png';
                const blob = await FJUtil.getBlobByUrl(imgUrl);
                if (!blob) {
                    throw new Error('blob not found');
                }
                const imgBlob = new File([blob], 'Image.png', { type: 'image/png' });

                if (imgBlob) {
                    dispatch(setVideoEffectStyleSelectId(key));
                    setTimeout(() => {
                        if (prompt) {
                            dispatch(this.changeTextValueAction(prompt));
                        }

                        if (currentItem.list.length === 2) {
                            dispatch(this.changeVideoEffectImageTypeIndexAction(1));
                        }

                        dispatch(this.uploadFileAction(imgBlob));
                    }, 200);
                }
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            }
        };
    },

    /**
     * @description 更新视频特效的图片上传
     * @param info
     * @param index
     * @returns {(function(*, *): void)|*}
     */
    updateVideoEffectUploadFileAction: function (info, index) {
        return (dispatch, getState) => {
            const state = getState();
            const { videoEffectStyleSelectId, imageTypeIndex } = state.AIVideoGenerator;
            const currentItem = VIDEO_EFFECT_STYLE_LIST.find(item => item.key === videoEffectStyleSelectId);
            const isDoubleImg = currentItem.list.length === 2 || currentItem.list[0].imgType === 'DOUBLE';

            // 双图特效 且 图片类型为双图 imageTypeIndex === 0
            if (isDoubleImg && imageTypeIndex === 0) {
                const videoEffectUploadTwoImageInfo = state.AIVideoGenerator.videoEffectUploadTwoImageInfo;
                const newList = videoEffectUploadTwoImageInfo.map((item, innerIndex) => {
                    if (innerIndex === index) {
                        return { ...info };
                    } else {
                        return { ...item };
                    }
                });
                dispatch(this.setSliceVideoEffectUploadTwoImageInfoAction(newList));
            } else {
                dispatch(this.setSliceVideoEffectUploadImageInfoAction({ ...info }));
            }
        };
    },
    updateVideoEffectUploadVideoInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceVideoEffectUploadVideoInfo(info));
        };
    },

    setSliceVideoEffectUploadTwoImageInfoAction: function (list) {
        return dispatch => {
            dispatch(setSliceVideoEffectUploadTwoImageInfo(list));
        };
    },

    setSliceVideoEffectUploadImageInfoAction: function (info) {
        return dispatch => {
            dispatch(setVideoEffectUploadImageInfo(info));
        };
    },
    changeVideoEffectImageTypeIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceVideoEffectImageTypeIndex(index));
        };
    },

    /**
     * 切换图片上传模式
     * @param {string} mode - 图片上传模式 (single/start-end/multi)
     */
    changeImageModeAction: function (mode) {
        return (dispatch, getState) => {
            const { currentModel } = getState().AIVideoGenerator;
            const currentModelConfig = AI_VIDEO_GENERATION_MODEL_LIST.find(item => item.value === currentModel);

            // REQUIREMENT: 如果当前是单图模式，则切换到支持首尾帧的模型 默认 Pro 模型
            if (currentModelConfig.mode === IMAGE_UPLOAD_MODES.SINGLE) {
                dispatch(this.setModelAction(AI_VIDEO_GENERATION_MODEL_LIST[1]));
                FJMessageStore.addMessage(FJLocalStore._('switched-to-a-model-that-supports-start-end-frame-editing'));
            }

            dispatch(setSliceImageMode(mode));
        };
    },

    /**
     * 统一图片数组的相关 actions
     */

    /**
     * 更新指定位置的图片
     * @param {number} index - 图片索引
     * @param {object} imageData - 图片数据
     */
    updateUploadMediaAction: function (index, imageData) {
        return dispatch => {
            dispatch(updateSliceUploadImage({ index, imageData }));
        };
    },

    /**
     * 移除指定位置的图片
     * @param {number} index - 图片索引
     */
    removeUploadImageAction: function (index) {
        return dispatch => {
            dispatch(removeSliceUploadImage(index));
        };
    },
    onVideoEffectDancePresetItemClickAction: function (item) {
        return async dispatch => {
            const previewUrl = FJConfig.videoEffectDanceStylePreviewPath + item.previewVideo;
            const originalUrl = FJConfig.videoEffectDanceStylePreviewPath + item.originVideo;
            dispatch(
                this.updateVideoEffectUploadVideoInfoAction({
                    src: previewUrl,
                    ...item.previewVideoInfo,
                    originalUrl,
                    type: 'web',
                    mediaType: 'VIDEO',
                    source: FJConstant.AI_VIDEO_FLEXCLIP,
                }),
            );
        };
    },
};

export default FJActionAIVideoGenerator;
